import Button from "@/common/components/Button";
import { DateInput } from "@/common/components/DateInput/DateInput";
import Modal from "@/common/components/Modal";
import { ModalMessageSimple } from "@/common/components/ModalMessageSimple";
import TextField from "@/common/components/TextField";
import { UnitTextField } from "@/common/components/UnitTextField";
import { FormTransformers } from "@/common/utils/formTransformers";
import { useMaintenanceEstablishmentChoiceManualEntryProposalEstablishmentAccept } from "@/features/maintenance/features/workflows/hooks/establishmentChoice/manualEntryProposals/useMaintenanceEstablishmentChoiceManualEntryProposalEstablishmentAccept";
import { MaintenanceForwardingData } from "@/features/maintenance/features/workflows/types/forwardings/maintenanceForwarding.type";
import { zodResolver } from "@hookform/resolvers/zod";
import { useQueryClient } from "@tanstack/react-query";
import { ClockIcon } from "lucide-react";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { useParams } from "react-router-dom";
import z from "zod";

interface MaintenanceEstablishmentChoiceManualEntryProposalEstablishmentAcceptProps {
  forwarding: MaintenanceForwardingData;
}

const MaintenanceEstablishmentChoiceManualEntryProposalEstablishmentAccept = ({
  forwarding,
}: MaintenanceEstablishmentChoiceManualEntryProposalEstablishmentAcceptProps) => {
  const { id } = useParams();
1
  const [isOpen, setIsOpen] = useState(false);

  const [messages, setMessages] = useState<string[] | boolean>(false);

  const queryClient = useQueryClient();

  const {
    control,
  } = useForm<any>({
    resolver: zodResolver(z.any()),
  }); // to be implemented

  const {
    mutate: establishmentAccept,
    isPending: establishmentAcceptIsPending,
  } = useMaintenanceEstablishmentChoiceManualEntryProposalEstablishmentAccept({
    establishmentChoiceEntryId: forwarding.establishment_choice_entry?.actual_proposal?.id,
    options: {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ['maintenanceWorkflow', id] });
        queryClient.invalidateQueries({ queryKey: ['maintenanceForwarding', forwarding.id] });

        setIsOpen(false);
      },
      onError: (error) => {
        FormTransformers.errorsTransformer({ setMessages })(error);
      },
    },
  });

  return (
    <>
      <Modal
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        Trigger={(
          <Button
            operationKlassToCheckPermission="Establishment::Maintenance::EstablishmentChoice::ManualEntryProposals::EstablishmentAccept"
          >
            Fazer proposta
          </Button>
        )}
        showClose={false}
        title="Fazer proposta"
        subtitle="Sugira uma data e horario para que o cliente traga o equipamento até o seu estabelecimento."
        titleClass="text-2xl"
        subtitleClassName="mt-2 text-white-400 hidden" // to be implemented
        bodyClassName="text-white-800 hidden" // to be implemented
        useCancellableFooter
        confirmButtonClassName="bg-blue-700 rounded-br-lg"
        cancelButtonClassName="bg-white-100 rounded-bl-lg"
        confirmButtonIsLoading={establishmentAcceptIsPending}
        onConfirm={() => establishmentAccept()}
        body={(
          <div className="flex flex-col gap-4">
            <div className="flex gap-3">
              <DateInput
                fieldName="date"
                control={control as any}
                label="Data sugerida"
                className="flex-1"
                markAsRequired
              />

              <TextField
                label="Horário sugerido"
                type="time"
                markAsRequired
                className="flex-1"
                LeftIcon={<ClockIcon className="w-5 h-5 text-white-400" />}
              />
            </div>

            <UnitTextField
              decimals={0}
              placeholder="Escreva aqui o prazo em dias"
              unit="dia(s)"
              label="Prazo em dias para envio do diagnostico e orçamento pós-check-in"
              markAsRequired
            />
          </div>
        )}
      />

      <ModalMessageSimple
        messages={messages}
        setMessages={setMessages}
        isError
      />
    </>
  );
}

export default MaintenanceEstablishmentChoiceManualEntryProposalEstablishmentAccept;
